import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-135c1dbf")

_pushScopeId("data-v-135c1dbf")
const _hoisted_1 = { class: "dhm_head native-drag flex_space_center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex_start_center" }, [
  /*#__PURE__*/_createVNode("i", { class: "keniu_icon" }),
  /*#__PURE__*/_createVNode("span", { class: "keniu_title" }, "可牛软件")
], -1)
const _hoisted_3 = { class: "flex_end_center" }
const _hoisted_4 = { class: "my_exchange" }
const _hoisted_5 = { class: "list_table" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "list_head" }, [
  /*#__PURE__*/_createVNode("ul", { class: "flex_start_center" }, [
    /*#__PURE__*/_createVNode("li", null, "序号"),
    /*#__PURE__*/_createVNode("li", null, "描述"),
    /*#__PURE__*/_createVNode("li", null, "兑换码"),
    /*#__PURE__*/_createVNode("li", null, "状态"),
    /*#__PURE__*/_createVNode("li", null, "有效期")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "list_body"
}
const _hoisted_8 = { class: "flex_start_center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("li", null, "1000", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("li", null, "可牛电脑助手会员30天", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("li", null, "23KJHFHNKJ", -1)
const _hoisted_12 = {
  key: 0,
  class: "li_active"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("li", null, "2021,11,23", -1)
const _hoisted_15 = {
  key: 1,
  class: "no_hava_dhm"
}
const _hoisted_16 = { class: "my_list_action flex_space_center" }
const _hoisted_17 = { class: "action_left flex_start_center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "隐藏已兑换/已过期的兑换码", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("i", {
          class: "close_icon native-nodrag",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeExchangeModel && _ctx.closeExchangeModel(...args)))
        })
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        (!_ctx.viewModel.list.length)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("ul", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                true
                  ? (_openBlock(), _createBlock("li", _hoisted_12, "未兑换"))
                  : (_openBlock(), _createBlock("li", _hoisted_13, "未兑换")),
                _hoisted_14,
                _createVNode("li", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyExchange && _ctx.copyExchange(...args)))
                }, "复制")
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_15, "您还没有会员兑换码"))
      ]),
      _createVNode("div", _hoisted_16, [
        _createVNode("div", _hoisted_17, [
          _createVNode("i", {
            class: { active: _ctx.viewModel.checked },
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCheckboxStatus && _ctx.toggleCheckboxStatus(...args)))
          }, null, 2),
          _hoisted_18
        ]),
        _createVNode("span", {
          class: "go_back",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, "返回")
      ])
    ])
  ], 64))
})